var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from 'redux-saga/effects';
import { SYNC_ORDER_REQUEST, syncStoreOrderFailure, syncStoreOrderSuccess, } from '../../actions';
import APIIN from '@/utils/APIIN';
const onSyncStoreOrder = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        console.log("value", action.payload.lastKDays);
        try {
            APIIN.post(`/sync/api/shopify/orders/sync`, {
                "channelId": action.payload.channelId,
                "lastKDays": action.payload.lastKDays,
            })
                .then(data => {
                resolve(data);
            })
                .catch(error => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* syncStoreOrderWorker(action) {
    try {
        const data = yield call(onSyncStoreOrder, action);
        yield put(syncStoreOrderSuccess(data));
    }
    catch (error) {
        yield put(syncStoreOrderFailure(error));
    }
}
export function* watchStoreSyncOrdersData() {
    yield takeLatest(SYNC_ORDER_REQUEST, syncStoreOrderWorker);
}
